export const SET_TRANSLATED_CALIBRATION_WELCOME_MESSAGE = 'SET_TRANSLATED_CALIBRATION_WELCOME_MESSAGE'



// WEBPACK FOOTER //
// ./src/store/modules/notificationmessage/types.js